import { Injectable } from '@angular/core';
import { Response, Http } from "@angular/http";
import "rxjs/Rx";

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

import { environment } from "../../../environments/environment";

@Injectable()
export class LookupService {
    constructor(private http: Http) { }

    load(): Promise<any> {
        this.defaultValues = null;

        const qs = environment.apiPath + '/api/lookups/getDefaultValues';

        return this.http
            .get(qs)
            .map((res: Response) => res.json())
            .toPromise()
            .then((data: any) => this.defaultValues = data)
            .catch((err: any) => Promise.resolve());
    }

    defaultValues: Array<{ defaultNameId: number, name: string, description: string, value: string, valueText: string, dataType: string }> = null;

    public getDefaultProvinceId(): number {
        return +this.getDefaultValue(4001, 41);
    }

    public getShowRememberMe(): boolean {
        let val = this.getDefaultValue(40054, "false");
        if (val.toString().toLowerCase() == "true") {
            return true;
        }
        return false;
    }

    public getReCaptchaSiteKey(): Observable<string> {
      //return this.getDefaultValue(40049, "6LfP-BMTAAAAAGzP92wvovolZkOdFKxOKTQ2leOr");

      const qs = environment.apiPath + '/api/lookups/GetReCaptchaSiteKey';
        return this.http.get(qs)
                .map((response: Response) => response.json() as string);
    }

    public getDefaultRedirectRoute() {
      return this.getDefaultValue(40059, '');
    }

    public getEV_ALS_OffenceDateMaxDaysInPast() {
        return this.getDefaultValue(40052, 5);
    }

    public getDefaultValue(id: number, defaultValue: any) {
        if (this.defaultValues == null) { return defaultValue; }
        let l = this.defaultValues.filter((s) => s.defaultNameId == id);
        if (l == null || l.length == 0) {
            return defaultValue;
        }
        else {
            return l[0].value;
        }
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/lookups/lookup.service.ts